




















































    
import {Vue, Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import { ClientProjectTask, ClientProjectTaskCreate } from '../../../../services/accounting.service';
import { FormMixin } from './../../../../mixins/FormMixin'
import {Random} from 'hcore/dist/random';

@Component({})
export default class ClientProjectTaskForm extends Mixins<FormMixin<ClientProjectTaskCreate, ClientProjectTask>>(FormMixin) {

    id!: string;

    created() {
        this.id = Random.alphanumeric(10);
    }

    empty: ClientProjectTaskCreate = Object.freeze({
        title: '',
        description: '',
        estimatedHours: 0,
        complete: false,
    });

    objToDto = (obj: ClientProjectTask) => {
        return {
            title: obj.title,
            description: obj.description,
            estimatedHours: obj.estimatedHours,
            complete: obj.complete,
        }
    }

    idFn = (obj: ClientProjectTask) => {
        return obj.id;
    }
}

